export default function Footer() {
  return (
    <div className="mt-8 border-t border-border/60 pt-4">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="py-4 text-sm text-muted-foreground text-center">
          &copy; {new Date().getFullYear()} Your Company, Inc. All rights reserved.
        </p>
      </div>
    </div>
  );
}